/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Storefront_VisibilityInputs */

const en_storefront_visibility = /** @type {(inputs: Storefront_VisibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storefront Visibility`)
};

const id_storefront_visibility = /** @type {(inputs: Storefront_VisibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visibilitas Etalase`)
};

/** @type {(inputs: Storefront_VisibilityInputs) => LocalizedString} */
const es_storefront_visibility = en_storefront_visibility;

/** @type {(inputs: Storefront_VisibilityInputs) => LocalizedString} */
const fr_storefront_visibility = en_storefront_visibility;

/** @type {(inputs: Storefront_VisibilityInputs) => LocalizedString} */
const de_storefront_visibility = en_storefront_visibility;

/** @type {(inputs: Storefront_VisibilityInputs) => LocalizedString} */
const ja_storefront_visibility = en_storefront_visibility;

/** @type {(inputs: Storefront_VisibilityInputs) => LocalizedString} */
const zh_storefront_visibility = en_storefront_visibility;

/** @type {(inputs: Storefront_VisibilityInputs) => LocalizedString} */
const ar_storefront_visibility = en_storefront_visibility;

/** @type {(inputs: Storefront_VisibilityInputs) => LocalizedString} */
const it_storefront_visibility = en_storefront_visibility;

/** @type {(inputs: Storefront_VisibilityInputs) => LocalizedString} */
const ru_storefront_visibility = en_storefront_visibility;

/** @type {(inputs: Storefront_VisibilityInputs) => LocalizedString} */
const pt_storefront_visibility = en_storefront_visibility;

/** @type {(inputs: Storefront_VisibilityInputs) => LocalizedString} */
const ko_storefront_visibility = en_storefront_visibility;

/**
* | output |
* | --- |
* | "Storefront Visibility" |
*
* @param {Storefront_VisibilityInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const storefront_visibility = /** @type {((inputs?: Storefront_VisibilityInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Storefront_VisibilityInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_storefront_visibility(inputs)
	if (locale === "es") return es_storefront_visibility(inputs)
	if (locale === "fr") return fr_storefront_visibility(inputs)
	if (locale === "de") return de_storefront_visibility(inputs)
	if (locale === "ja") return ja_storefront_visibility(inputs)
	if (locale === "zh") return zh_storefront_visibility(inputs)
	if (locale === "ar") return ar_storefront_visibility(inputs)
	if (locale === "id") return id_storefront_visibility(inputs)
	if (locale === "it") return it_storefront_visibility(inputs)
	if (locale === "ru") return ru_storefront_visibility(inputs)
	if (locale === "pt") return pt_storefront_visibility(inputs)
	return ko_storefront_visibility(inputs)
});